import Text from '../Text';
import Game from '../../Game';
import AnimationComponent from '../../Component/Animation';
import Renderable from '../../Component/Renderable';

export default class BonusTextEffect extends Text {
    public create(params: any): void {
        super.create({
            name: 'bonusText',
            style: Game.style.getStyle('score.text'),
            ...params,
        });

        this.addComponent<Renderable>(Renderable, params);
        this.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'BonusText',
            ...params,
        });
    }
}
